import {registerRoute as workbox_routing_registerRoute} from '/home/jenkins/agent/workspace/pplus/www-web/util/web-paramountplus-intl/node_modules/.pnpm/workbox-routing@7.3.0/node_modules/workbox-routing/registerRoute.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/home/jenkins/agent/workspace/pplus/www-web/util/web-paramountplus-intl/node_modules/.pnpm/workbox-strategies@7.3.0/node_modules/workbox-strategies/CacheFirst.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/home/jenkins/agent/workspace/pplus/www-web/util/web-paramountplus-intl/node_modules/.pnpm/workbox-core@7.3.0/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/jenkins/agent/workspace/pplus/www-web/util/web-paramountplus-intl/node_modules/.pnpm/workbox-precaching@7.3.0/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */


importScripts(
  "https://js.appboycdn.com/web-sdk/4.8/service-worker.js"
);







self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/assets/build/css/fonts/fonts-8ac80e87d39ce4e32219.min.css",
    "revision": null
  },
  {
    "url": "/assets/build/css/fonts/fontsBlack-3d4be6698e70327d6bdf.min.css",
    "revision": null
  },
  {
    "url": "/assets/build/css/pages/homepage-391a5a10040f16be0cc3.min.css",
    "revision": null
  },
  {
    "url": "/assets/build/css/pages/showHome-0da252252ec95d587c86.min.css",
    "revision": null
  },
  {
    "url": "/assets/build/css/pages/showVideo-372a2cc61b1aa0afbcbb.min.css",
    "revision": null
  },
  {
    "url": "/assets/build/css/pages/showVideoEdge-ec3fe4d3176b9a8d2f7c.min.css",
    "revision": null
  },
  {
    "url": "/assets/build/css/pages/showbrowse-3a55ffbaeed1e728fef6.min.css",
    "revision": null
  },
  {
    "url": "/assets/build/js/homepage-08bb5c7737c25fecc77f.min.js",
    "revision": null
  },
  {
    "url": "/assets/build/js/show/videoBottom-fd4d1863fce0826de6b5.min.js",
    "revision": null
  },
  {
    "url": "/assets/build/js/show/videoTop-0db6a0d857e679594c42.min.js",
    "revision": null
  },
  {
    "url": "/assets/build/js/show/videoTopEdge-8643d139556f4a7a13b4.min.js",
    "revision": null
  },
  {
    "url": "/assets/build/js/showHome-af9042d688d4e2aa2649.min.js",
    "revision": null
  },
  {
    "url": "/assets/build/js/showbrowse-5c7becbc1dd7b4a38d25.min.js",
    "revision": null
  }
], {});




workbox_routing_registerRoute(/\.(?:css)$/, new workbox_strategies_CacheFirst({ "cacheName":"css-static", plugins: [] }), 'GET');




